import { useCallback, useEffect, useMemo } from "react"

import { useParams } from "react-router-dom"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { useMapDispatchContext } from "@l2r-front/l2r-map"
import { useNetworksDispatchContext } from "@l2r-front/l2r-networks"
import { BottomSheetContent, useIsMobileDevice } from "@l2r-front/l2r-ui"
import { useNavigateWithSearchParams } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { RoadsideSidebarComponents } from "../../components/RoadsideSidebarComponents"
import { useRoadsideStateContext } from "../../contexts/RoadsideContext"

import * as Styled from "./RoadsideSidebar.styled"

export function RoadsideSidebar() {

    const { t } = useTranslation([I18N_NAMESPACE])
    const { ascendantCodes, descendantCodes } = useRoadsideStateContext()
    const isMobile = useIsMobileDevice()
    const { getMapRef } = useMapDispatchContext()
    const { road } = useParams()
    const { setRoadSearched } = useNetworksDispatchContext()
    const navigate = useNavigateWithSearchParams()

    const additionalSidebars = useMemo(() => {
        if (isMobile) {
            return null
        }

        return [...ascendantCodes]
            .reverse()
            .filter((_, index) => ((index % 2 === 1) && ((ascendantCodes.length > index + 1) || descendantCodes.length > 1)))
            .map((code, index) => (
                <Styled.AdditionalSidebar key={code} index={index} >
                    <Styled.RoadsideTypeList baseRoadsideTypeCode={code} />
                </Styled.AdditionalSidebar>
            ))
    }, [ascendantCodes, descendantCodes, isMobile])

    const navigateBack = useCallback(() => {
        setRoadSearched(null)
        navigate("..")
    }, [navigate, setRoadSearched])

    useEffect(() => {
        const map = getMapRef()?.getMap()
        if (map?.style) {
            map?.resize()
        }
    }, [ascendantCodes, getMapRef])

    return (
        <BottomSheetContent
            id="roadside-sidebar"
            onBack={road ? navigateBack : null}
            title={t(I18N_NAMESPACE, `containers.roadsideSidebar.${road ? "roadTitle" : "title"}`)}
        >
            <Styled.RoadsideSidebarContainer>
                <Styled.Container>
                    <RoadsideSidebarComponents />
                </Styled.Container>
                {additionalSidebars}
            </Styled.RoadsideSidebarContainer>
        </BottomSheetContent>
    )
}
